import styled, { keyframes } from 'styled-components';

// Animations modernes
export const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Container principal moderne
export const DashboardContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  animation: ${fadeIn} 0.6s ease-out;
`;

// Header moderne
export const Header = styled.header`
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 100;
`;

export const HeaderContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const HeaderTitle = styled.div`
  h1 {
    font-size: 1.875rem;
    font-weight: 800;
    color: #1f2937;
    margin: 0 0 0.25rem 0;
    letter-spacing: -0.025em;
  }
  
  p {
    color: #6b7280;
    margin: 0;
    font-size: 0.875rem;
  }
  
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const LogoutButton = styled.button`
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  
  &:hover {
    background: linear-gradient(135deg, #dc2626, #b91c1c);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

// Contenu principal
export const MainContent = styled.main`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

// Toast notification moderne
export const ToastContainer = styled.div<{ $show: boolean }>`
  position: fixed;
  top: 2rem;
  right: 2rem;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(16, 185, 129, 0.4);
  z-index: 1000;
  transform: translateX(${props => props.$show ? '0' : '100%'});
  opacity: ${props => props.$show ? '1' : '0'};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  min-width: 300px;
  
  @media (max-width: 768px) {
    top: 1rem;
    right: 1rem;
    left: 1rem;
    min-width: auto;
    transform: translateY(${props => props.$show ? '0' : '-100%'});
  }
`;

// Loading et états vides
export const LoadingSpinner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  color: #6b7280;
  
  .spinner {
    font-size: 2rem;
    color: #3b82f6;
    margin-bottom: 1rem;
    animation: ${spin} 1s linear infinite;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  color: #6b7280;
  
  .icon {
    font-size: 4rem;
    color: #d1d5db;
    margin-bottom: 1.5rem;
  }
  
  h3 {
    font-size: 1.25rem;
    color: #374151;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
  
  p {
    font-size: 1rem;
  }
`;

export const ErrorMessage = styled.div`
  background: linear-gradient(135deg, #fee2e2, #fecaca);
  border: 1px solid #fca5a5;
  color: #dc2626;
  padding: 1rem 2rem;
  margin-bottom: 2rem;
  border-radius: 12px;
  font-weight: 600;
  text-align: center;
  animation: ${slideIn} 0.3s ease-out;
`;
